import React from 'react';
import { Box, Button, Stack } from '@mui/material';
import { theme } from '../../../../../common/styles/theme';
import MessageCard from '../../shared/components/MessageCard/MessageCard';
import { ICallNoticeProps } from './types';

export function CallNotice({
	notice,
	recordingsReady,
	onClose,
}: ICallNoticeProps) {

	const [title, text] = notice === 'finished'
		? ['This call has ended', 'This meeting has already finished and can’t be reopened.']
		: notice === 'notFound'
		? ['Meeting not found', 'Check the link or ask for a new one.']
		: ['Your session has ended', notice === 'endedNothing'
			? 'Nothing was recorded'
			: recordingsReady
			? 'The recording is ready'
			: 'Call recording is being processed'];

	return (
		<Box
			sx={{
				width: 1,
				p: theme.spacing(2),

				'.card': {
					width: 1,
				},
			}}
		>
			<MessageCard hideBack >
				<Stack
					gap={2}
					alignItems={'center'}
				>
					<Stack
						gap={1}
						alignItems={'center'}
					>
						<Box
							sx={{
								textAlign: 'center',
								fontSize: theme.typography.h5,
							}}
						>
							{title}
						</Box>
						<Box
							sx={{
								textAlign: 'center',
								fontSize: theme.typography.subtitle2,
							}}
						>
							{text}
						</Box>
					</Stack>
					<Button
						variant={'contained'}
						onClick={onClose}
					>
						New call
					</Button>
				</Stack>
			</MessageCard>
		</Box>
	);
}
